import 'lazysizes';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';

import Spa from './barba/Spa';
import Header from './components/Header';
import AutoplayVideos from './components/AutoplayVideos';
import Cursors from './components/Cursors';
import Newsletter from './components/Newsletter';
import ScrollLocking from './components/ScrollLocking';

export class Flussbad {
	constructor() {
		// Promises waarop gewacht  wordt. Standaard wordt er gewacht op het 'DOMContentLoaded' event
		Promise.all([Flussbad.domReady()]).then(() => this.init());
	}

	init() {
		new Header();
		new AutoplayVideos();
		new Newsletter();
		new ScrollLocking();

		this.cursors = document.querySelector('[data-cursors]');
		if (this.cursors) {
			new Cursors(this.cursors);
		}

		window.addEventListener('resize', () => {
			this.resize();
		});
		this.resize();

		document.addEventListener('bless', (e) => {
			if (!window.VIVENU) {
				return;
			}

			window.VIVENU.presenter.replaceLinks();
		});

		jQuery(document).on('submit', 'form[data-formid]', function (evt) {
			const el = evt.target;
			if (!el.querySelector('[name="version_hash"]')) {
				const hiddenInput = `<input
					type="hidden"
					name="version_hash"
					value="${window.gform_theme_config?.common?.form?.honeypot?.version_hash}"
				/>`;
				el.insertAdjacentHTML('beforeend', hiddenInput);
			}
		});

		new Spa();
	}

	resize() {
		let vh = window.innerHeight / 100;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
	}

	static domReady() {
		return new Promise((resolve) => document.addEventListener('DOMContentLoaded', resolve));
	}
}

new Flussbad();
